import React from 'react';
import "./Dialog.less";
import Dropdown from '../Dropdown/Dropdown';

class Dialog extends React.Component {
    static popupInstance;
    static chooseOption = function() {};

    constructor(props) {
        super(props)
        Dialog.popupInstance = this;

        this.state = {
            open: false,
            title: "",
            description: "",
            descriptionType: "",
            options: [
                {label: "OK", className:"positiveConfirm"},
                {label: "Abbrechen", className:"cancel"},
            ],
            inputs: [],
            panelOptions: {className: null},
        }
    }

    static Alert(args) {        
        if (Dialog.popupInstance == null) {
            console.error("Please put an instance of the dialog class into the render function of your Overlay Components.")
            return;
        }
        document.body.style.overflowX = "hidden"; 
        document.body.style.overflowY = "hidden";
        var newState = {
            open: true,
            title: args.title ?? "",
            description: args.description ?? "Sind Sie sicher?",
            descriptionType: args.descriptionType ?? "",
            options: args.options ?? [
                {label: "OK", className:"positiveConfirm"},
                {label: "Abbrechen", className:""},
            ],
            inputs: args.inputs ?? [],
            panelOptions: args.panelOptions,
        };

        if (args.inputs != null)
        {
            args.inputs.forEach(element => 
                {
                    if (element.type === "select")
                        newState[element.name] = 0;
                    else
                    {
                        newState[element.name] = "";
                    }
                }
            )
        }        

        Dialog.popupInstance.setState(newState);
        return new Promise((resolve, reject) => {
            let optionChosen = -1;
            new Promise((resolve) => { Dialog.chooseOption = resolve }).then((result) => {                     
                
                optionChosen = result;
                var returnObj = {};
                
                if (Dialog.popupInstance.state.inputs == null) returnObj = optionChosen;
                else if (Dialog.popupInstance.state.inputs.length === 0) returnObj = optionChosen;
                else
                {
                    returnObj["Option"] = optionChosen;
                    Dialog.popupInstance.state.inputs.forEach(element => {
                        returnObj[element.name] = Dialog.popupInstance.state[element.name];
                    });
                }
            
                Dialog.popupInstance.setState({
                    open: false,
                    inputs: []
                })
                document.body.style.overflowX = "hidden"; 
                document.body.style.overflowY = "auto";
                resolve(returnObj)
            });
        })
    }

    UpdateStateInput(property, value)
    {
        var newObject = {};        
        newObject[property] = value;        
        this.setState(newObject);
    }

    preventEvent(e)
    {
        e.preventDefault();
    }

    render() {
        return (
            <div className={"dialogOverlay " + (this.state.open ? "open" : "")}>
                <div className={"panel "+ (this.state.panelOptions ? this.state.panelOptions.className : null)}>
                    <div className="fullWidth">
                            <h3>{this.state.title}</h3>
                        <div className="leftAligned">
                        {this.state.descriptionType === "htmlArray" ? this.state.description.map((desc, k) => {return(desc)}) : <p>{this.state.description}</p>}
                        </div>
                        <div>
                        
                        {this.state.inputs.map((v, k) => {
                            if (v.type === 'text')
                                return <input key={`input ${k}`} type={v.type} className={"dialogButton"} placeholder={v.name} onChange={(e) => this.UpdateStateInput(v.name, e.target.value)}>
                                </input>
                            else if (v.type === 'select')
                            {
                                var selections = [];
                                v.options.map((val, idx) =>
                                {
                                    selections.push({value: idx, text: val})
                                    return "";
                                });                                

                                return <div key={`input ${k}`} className='dialogDropdown'>
                                    <Dropdown className="company_worker_dropdown" value={0} selections={selections} onChange={(value) => this.UpdateStateInput(v.name, value)}/>
                                </div>
                            }
                            else
                            {
                                return "";
                            }
                            })}
                            
                        </div>
                        <div className="buttonFlex">
                            {this.state.options.map((v, k) => {                                
                                return <button key={k} className={"dialogButton " + v.className} onClick={() => Dialog.chooseOption(k)}>
                                    {v.label}
                                </button>
                            })}
                        </div>
                        
                    </div>
                </div>
            </div>
        )
    }
};

export default Dialog;